import { FilterField, Position, Size } from 'coreOld/enums';
import { dateOptions, restrictionTypesOptions } from 'partsOld/constants';
import { useGetBaseUoms } from 'partsOld/hooks';
import { manufacturersService, partsService } from 'partsOld/services';

export const filtersConfig = () => [
  {
    name: 'add_part',
    type: FilterField.ADD_PART,
    flex: 10,
    paddingLeft: 24,
  },
  {
    name: 'import',
    type: FilterField.IMPORT,
    flex: 5,
    paddingRight: 24,
  },
  {
    name: 'query',
    type: FilterField.SEARCH,
    flex: 60,
    minWidth: 280,
    border: Position.LEFT,
    paddingLeft: 24,
    paddingRight: 24,
  },
  {
    name: 'advancedFilters',
    type: FilterField.ADVANCED,
    minWidth: 20,
    border: Position.LEFT,
    paddingLeft: 16,
    paddingRight: 16,
  },
  {
    name: 'updatedAt',
    type: FilterField.DATE,
    width: 180,
    props: {
      placeholder: 'Updated',
      options: dateOptions,
      rightPosition: true,
    },
    border: Position.LEFT,
    paddingLeft: 24,
  },
  {
    name: 'restrictionType',
    type: FilterField.SELECT,
    width: 180,
    props: {
      options: restrictionTypesOptions(),
    },
    paddingRight: 24,
  },
];

export const advancedFiltersConfig = [
  {
    name: 'part',
    label: 'Part Number(s)',
    type: FilterField.AUTOCOMPLETE,
    props: {
      getOptions: partsService.getManyAutocomplete,
      getLabel: (opt) => opt?.number,
      requestPayload: {
        manufacturerIncluded: 1,
      },
      isMulti: true,
      isClearable: false,
      size: Size.MD,
    },
  },
  {
    name: 'manufacturerIds',
    label: 'Manufacturer(s)',
    type: FilterField.AUTOCOMPLETE,
    props: {
      getOptions: manufacturersService.getMany,
      isMulti: true,
      isClearable: false,
      size: Size.MD,
    },
  },
  {
    name: 'partBaseCode',
    label: 'Base Code',
    type: FilterField.TEXTFIELD,
  },
  {
    name: 'pricingGroup',
    label: 'Pricing Group',
    type: FilterField.TEXTFIELD,
  },
  {
    name: 'purchaseCostRange',
    label: 'Purchase Cost Range',
    type: FilterField.RANGE,
    checkbox: {
      label: 'No Cost',
      value: '0',
    },
  },
  {
    name: 'inventoryQuantityRange',
    label: 'Inventory',
    type: FilterField.RANGE,
    checkbox: {
      label: 'No Inventory',
      value: '0',
    },
  },
  {
    name: 'externalParts',
    label: 'External Parts',
    type: FilterField.CHECKBOX_GROUP,
    checkboxes: [
      {
        label: 'Matched',
        value: 'matched',
      },
      {
        label: 'Unmatched',
        value: 'unmatched',
      },
    ],
    isMulti: false,
  },
  {
    name: 'uoms',
    label: 'Unit(s) of Measure',
    type: FilterField.INPUT_GROUP,
    individualFields: true,
    fields: [
      {
        name: 'uomIds',
        type: FilterField.SELECT,
        props: {
          useGetOptions: useGetBaseUoms,
          getValue: (opt) => opt?.id,
          getLabel: (opt) => opt?.name,
          requestPayload: {
            filters: {
              isBase: 1,
            },
          },
          placeholder: 'Base UOM',
          isMulti: true,
          size: Size.MD,
        },
      },
      {
        name: 'salesUom',
        type: FilterField.TEXTFIELD,
        props: {
          placeholder: 'Sales UOM',
        },
      },
      {
        name: 'externalUom',
        type: FilterField.TEXTFIELD,
        props: {
          placeholder: 'External UOM',
        },
      },
      {
        name: 'purchaseCostUom',
        type: FilterField.TEXTFIELD,
        props: {
          placeholder: 'Purchase UOM',
        },
      },
    ],
  },
];
